import { render, staticRenderFns } from "./WebhookEdit.vue?vue&type=template&id=65266d57&scoped=true&"
import script from "./WebhookEdit.vue?vue&type=script&lang=js&"
export * from "./WebhookEdit.vue?vue&type=script&lang=js&"
import style0 from "./WebhookEdit.vue?vue&type=style&index=0&id=65266d57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65266d57",
  null
  
)

export default component.exports